import { render, staticRenderFns } from "./Snowflake.vue?vue&type=template&id=af5e4c5a&scoped=true"
import script from "./Snowflake.vue?vue&type=script&lang=js"
export * from "./Snowflake.vue?vue&type=script&lang=js"
import style0 from "./Snowflake.vue?vue&type=style&index=0&id=af5e4c5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5e4c5a",
  null
  
)

export default component.exports